import { castDraft } from 'immer';
import React, { createContext, PropsWithChildren, useMemo, useReducer } from 'react';
import { DispatchState } from 'shared/hooks/useDispatchState';
import { InventoryDispatchObject } from '../store/actions';
import { initialState, inventoryContextReducer, InventoryState } from '../store/reducer';

export type InventoryDispatch<T = any> = React.Dispatch<InventoryDispatchObject<T>>;

export type InventoryContextType = DispatchState<InventoryState, InventoryDispatch>;

export const InventoryContext = createContext({} as InventoryContextType);

type InventoryProviderProps = PropsWithChildren<{
  extraState?: Partial<InventoryState>;
  testDispatch?: InventoryDispatch;
}>;

export const InventoryProvider: React.FC<InventoryProviderProps> = ({
  children,
  extraState = {},
  testDispatch,
}: InventoryProviderProps) => {
  const [state, dispatch] = useReducer(inventoryContextReducer, { ...initialState, ...extraState });

  const value = useMemo(() => {
    return { dispatch: testDispatch || dispatch, state: castDraft(state) };
  }, [dispatch, state]);

  return <InventoryContext.Provider value={value}>{children}</InventoryContext.Provider>;
};
